/* eslint-disable max-classes-per-file */
import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { Mix, LoaderMixin, PropertyDefaultValue } from '../../common';
import { i18nMixin } from '../../decorators';
import { getRouteOptionsAndParams } from '../ki-app';
import { getCurrentApi } from '../../api';
import nls from '../../locales/index';

@customElement('wwp-html')
export default class WwpHtml extends Mix(
  LitElement,
  LoaderMixin,
  PropertyDefaultValue,
  [i18nMixin, { nls }],
) {
  api = getCurrentApi();

  static styles = css`
    :host {
      display: flex;
      width: 100%;
      height: 100%;
    }
    iframe {
      flex: 1;
      width: 100%;
      height: 100%;
      border: none;
    }
    a {
      font-size: 2em;
      text-align: center;
      display: block;
      margin-top: 20%;
    }
  `;

  /** Determines whether static files in public (basePath) should be used
   * @remark `false` uses API dataPath (see app.json), usually S3 bucket
   * @remark `true` uses public/{basePath}
   */
  @property({ type: Boolean })
  useBasePath: boolean = false;

  /** Filename */
  @property({ type: String })
  content: string = '';

  /** Sub-directories */
  @property({ type: String })
  contentFolder: string = 'html';

  /** HTML or PDF file
   * @remark Default: `html`
   */
  @property({ type: String })
  type: 'html' | 'pdf' = 'html';

  /** BasePath in static file system inside `public` */
  @property({ type: String })
  basePath: string = '.';

  /** Root path for each request */
  get root() {
    return this.useBasePath ? this.basePath : this.api.dataPath;
  }

  // Vaadin Router Method that gets called after this component is called
  // eslint-disable-next-line no-unused-vars
  onAfterEnter(location) {
    const params = getRouteOptionsAndParams(location, ['content']);

    this.content = params.content ?? params.options?.content;
    if (!this.content) console.error('Content/Filename is not defined!');
    this.contentFolder = params.options.contentFolder ?? this.contentFolder;
    this.type = params.options.type ?? this.type;
    this.basePath = params.options.basePath ?? this.basePath;
    /** True for static html or pdf content; False for API content, e.g. via S3 Bucket */
    this.useBasePath = params.options.useBasePath ?? this.useBasePath;
    console.debug(
      'Report path:',
      `${this.root}/${this.contentFolder}/${this.content}.${this.type}`,
    );
  }

  renderHTML() {
    return html`<iframe
      title="content"
      src="${this.root}/${this.contentFolder}/${this.content}.${this.type}"
    ></iframe>`;
  }

  /* eslint-disable lit/no-invalid-html */
  renderPDF() {
    this.contentFolder = this.contentFolder || '';

    const fullUrl = new URL(
      `${this.root}/${this.contentFolder}/${this.content}.${this.type}`,
      window.location.origin,
    ).href;

    return html`<iframe
      title="pdf"
      src="${fullUrl}"
      style="width:100%; height:100%;"
    ></iframe>`;
  }
  /* eslint-enable lit/no-invalid-html */

  render() {
    // language=html
    return this.type === 'pdf' ? this.renderPDF() : this.renderHTML();
  }
}
